<template>
  <section class="header">
    <div class="header-box">
      <a href="/#/" class="header-box-logo-link">
        <div class="header-box-logo">
          <img src="@/assets/image/common/dahanLOGO.png" alt="logo">
        </div>
      </a>
      <!-- <div class="header-nav">
        <ul>
          <li v-for="(item,index) in headerList" :key="index" class="nav-item">
            <div @click="gotoUrl(item)" class="nav-item-title">{{item.title}}</div>
            <div v-if="item.imgUrl" class="nav-content">
              <div class="nav-des-back">
                <div class="headernav-bg">
                  <img :src="require('@/assets/image/common/'+item.imgUrl)" alt="背景图">
                </div>
                <div class="headernav-tent">
                  <div class="des-title">{{item.title1}}</div>
                  <p class="des-desc">{{item.desc}}</p>
                </div>
              </div>
              <div class="nav-menu">
                <div class="menu-title">{{item.navTitle}}</div>
                <ul>
                  <li
                    v-for="(item1,index1) in item.list"
                    @click="gotoRouter(item1,item)"
                    :key="index1"
                  >
                    <a>{{item1.title}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>-->
      <div class="header-nav">
        <ul>
          <li v-for="(item,index) in headerList" :key="index" class="nav-item">
            <div @click="gotoUrl(item)" class="nav-item-title">{{item.title}}</div>
            <ul v-if="item.list.length > 0" :key="index" class="nav-item-box">
              <li v-for="(item1,index1) in item.list" @click="gotoRouter(item1,item)" :key="index1">
                <a>{{item1.title}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
// import $ from 'jquery'
import { getIndustryList } from '@/api/layout'
export default {
  name: 'Header',
  data () {
    return {
      headerList: [
        {
          title: '首页',
          title1: '',
          desc: '',
          url: '/',
          imgUrl: '',
          navTitle: '',
          list: []
        },
        {
          title: '走进大汉',
          title1: '',
          desc: '',
          url: '/pc/comdetail',
          imgUrl: 'groupbanner.jpg',
          navTitle: '走进大汉',
          list: [
            { url: '/pc/comdetail', title: '集团概况', name: 'GroupIntroduce', index: 0 },
            { url: '/pc/comdetail', title: '董事长', name: 'Leader', index: 1 },
            { url: '/pc/comdetail', title: '价值主张', name: 'ShowValue', index: 2 },
            // { url: '/pc/comdetail', title: '组织架构', name: 'Origanize', index: 3 },
            { url: '/pc/comdetail', title: '大汉荣誉', name: 'ComHonor', index: 3 }
          ]
        },
        {
          title: '新闻中心',
          title1: '',
          desc: '',
          url: '/pc/comnews',
          imgUrl: 'newscenter.jpg',
          navTitle: '新闻中心',
          list: [
            {
              url: '/pc/comnews',
              title: '集团新闻',
              name: 'GroupNews',
              index: 0
            },
            { url: '/pc/comnews', title: '媒体视角', name: 'MediaView', index: 1 },
            // { url: '/pc/comnews', title: '大汉公益', name: 'MediaWelfare', index: 2 },
            { url: '/pc/comnews', title: '多媒体中心', name: 'MediaCenter', index: 2 }
          ]
        },
        {
          title: '产业布局',
          title1: '',
          desc: '',
          url: '/pc/layout',
          imgUrl: 'layout1.jpg',
          navTitle: '产业布局',
          list: []
        },
        {
          title: '党群文化',
          title1: '',
          desc: '',
          url: '/pc/partyaccess',
          imgUrl: 'partwenhua.jpg',
          navTitle: '党群文化',
          list: [
            {
              url: '/pc/partyaccess',
              title: '红书包',
              name: 'RedBag',
              index: 0
            },
            { url: '/pc/partyaccess', title: '红管家', name: 'RedAdmin', index: 1 },
            { url: '/pc/partyaccess', title: '红青年', name: 'RedYoung', index: 2 },
            { url: '/pc/partyaccess', title: '红妈妈', name: 'RedMon', index: 3 },
            { url: '/pc/partyaccess', title: '红旗帜', name: 'RedFlag', index: 4 },
            { url: '/pc/partyaccess', title: '红春晚', name: 'RedSpring', index: 5 },
            { url: '/pc/partyaccess', title: '红展馆', name: 'RedShow', index: 6 }
          ]
        },
        {
          title: '数字大汉',
          title1: '',
          desc: '',
          url: '/pc/digitization',
          imgUrl: 'mathdahanbanner.jpg',
          navTitle: '数字大汉',
          list: [
            // { url: '/pc/digitization', title: '傅胜龙语录', name: 'fuSaid' },
            { url: '/pc/digitization', title: '数字化产品', name: 'products' }]
        },
        {
          title: '采招平台',
          title1: '',
          desc: '',
          url: 'https://zhaocai.dahanjsy.com/',
          imgUrl: '',
          navTitle: '',
          list: []
        },
        {
          title: '人才招聘',
          title1: '',
          desc: '',
          url: '/pc/recruitment',
          imgUrl: 'recruitbanner.jpg',
          navTitle: '人才招聘',
          list: [
            // { url: '/pc/recruitment', title: '人才招聘', name: 'system' },
            { url: '/pc/campus', title: '校园招聘' },
            { url: 'https://company.zhaopin.com/CZ137478970.htm', title: '社会招聘' }
            // { url: '/pc/excellent', title: '优秀人才' }
          ]
        },
        {
          title: '廉政建设',
          title1: '',
          desc: '',
          url: '/pc/construction',
          imgUrl: 'construction.jpg',
          navTitle: '廉政建设',
          list: [
            // { url: '/pc/construction', name: 'activity', title: '往期活动' },
            { url: '/pc/report', title: '举报入口' }]
        }
      ]
    }
  },
  created () {
    this.getIndustryList()
  },
  mounted () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
    window.addEventListener('scroll', this.onScroll)
  },
  methods: {
    // 页面滚动事件
    // onScroll () {
    //   $(window).scroll(function () {
    //     let isok = true
    //     let t = document.documentElement.scrollTop || document.body.scrollTop
    //     if (t >= 200 && isok) {
    //       $('.header')
    //         .css('background', 'rgba(255, 255, 255, 1)')
    //         .css('boxShadow', '0 0 10px rgb(0 0 0 / 20%)')
    //         .css('top', '-30px')
    //         .css('transition', 'all .5s cubic-bezier(.645, .045, .355, 1)')
    //       // $('.header-nav').css('lineHeight', '90px')

    //       $('.nav-item').addClass('addAnimation')
    //       $('.header-box-logo').addClass('isBig')
    //       isok = false
    //     } else {
    //       $('.header')
    //         .css('background', 'rgba(255, 255, 255, 0.5)')
    //         .css('boxShadow', '0 0')
    //         .css('top', '0')
    //         .css('transition', 'all 0.3s cubic-bezier(.645, .045, .355, 1)')
    //       // $('.header-nav').css('lineHeight', '55px')
    //       $('.nav-item').removeClass('addAnimation')
    //       $('.header-box-logo').removeClass('isBig')
    //       isok = false
    //     }
    //   })
    // },

    // 离开时注销页面中的scroll
    beforeDestroy () {
      window.removeEventListener('scroll', this.onScroll)
    },
    // 导航栏路由跳转
    gotoUrl (item) {
      let reg = RegExp(/http/)
      if (!reg.test(item.url)) {
        this.$router.push(item.url)
      } else {
        window.open(item.url)
      }
    },
    // 子路由 路由跳转
    gotoRouter (item, fitem) {
      let reg = RegExp(/http/)
      if (!reg.test(item.url)) {
        this.$router.push({
          path: item.url,
          query: {
            name: item.name,
            index: item.index
          }
        })
        if (fitem.title === '产业布局') {
          this.$router.push({
            path: item.url,
            query: {
              name: item.name,
              index: item.index,
              title: item.title
            }
          })
        }
      } else {
        window.open(item.url)
      }
    },
    // 获取产业布局的行业分类
    async getIndustryList () {
      const { data } = await getIndustryList({ typeCode: 'company_category' })
      // 人为绑定index
      for (let i = 0; i < data.length; i++) {
        data[i].index = i
      }
      this.findLayout(data)
    },
    // 动态添加产业布局的导航栏
    findLayout (data) {
      for (let i = 0; i < this.headerList.length; i++) {
        if (this.headerList[i].title === '产业布局') {
          for (let j = 0; j < data.length; j++) {
            this.headerList[i].list.push({ url: '/pc/layout', title: data[j].name, name: data[j].code, index: data[j].index })
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../css/common.less');
.addAnimation {
  line-height: 140px !important;
}
.isBig {
  transform: scale(1) !important;
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue